import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const IntroVariant1 = lazyWithPreload(() => import('./IntroVariant1'))
export const IntroLikeChat = lazyWithPreload(() => import('./IntroLikeChat'))
export const IntroVariantRefund = lazyWithPreload(
  () => import('./IntroVariantRefund'),
)
export const IntroInfluencers = lazyWithPreload(
  () => import('./IntroInfluencers'),
)
export const IntroGiftCard = lazyWithPreload(() => import('./IntroGiftCard'))
export const LoadingIntro = lazyWithPreload(() => import('./LoadingIntro'))
export const LoadingIntro2 = lazyWithPreload(() => import('./LoadingIntro2'))
export const LoadingIntro3 = lazyWithPreload(() => import('./LoadingIntro3'))
export const IntroPlan = lazyWithPreload(() => import('./IntroPlan'))
